var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pb-6" },
            [
              _vm._v(" Listados de Alianzas "),
              _c("v-spacer"),
              _c("v-text-field", {
                staticStyle: { "max-width": "400px" },
                attrs: {
                  "append-icon": "mdi-magnify",
                  label: "Buscar",
                  "single-line": "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _c("v-spacer"),
            ],
            1
          ),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.configs,
              search: _vm.search,
              "custom-filter": _vm.customFilter,
            },
            scopedSlots: _vm._u([
              {
                key: "item.NombreCompania",
                fn: function ({ item }) {
                  return [
                    _vm._v(
                      " [ " +
                        _vm._s(item.IdCompania) +
                        " ] " +
                        _vm._s(item.NombreCompania) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "item.acciones",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-menu",
                      {
                        attrs: { "offset-y": "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            icon: "",
                                            color: "primary",
                                            title: "Acciones",
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c("v-icon", [
                                        _vm._v(" mdi-dots-vertical "),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openAudit(item, "report")
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-file-excel-outline"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c("v-list-item-title", [
                                  _vm._v(" Reporte redenciones "),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openAudit(item, "logs")
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-file-code-outline"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c("v-list-item-title", [
                                  _vm._v(" Descargar logs "),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "item.NombreAlianza",
                fn: function ({ item }) {
                  return [_vm._v(" " + _vm._s(item.NombreAlianza) + " ")]
                },
              },
              {
                key: "item.CodigoAlianza",
                fn: function ({ item }) {
                  return [_vm._v(" " + _vm._s(item.CodigoAlianza) + " ")]
                },
              },
              {
                key: "item.stores",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          icon: "",
                          color: "primary",
                          title: "Terminales",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openStores(item)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v(" mdi-store ")])],
                      1
                    ),
                  ]
                },
              },
              {
                key: "item.Active",
                fn: function ({ item }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-center" },
                      [
                        _c("v-switch", {
                          attrs: { inset: "" },
                          on: {
                            change: function ($event) {
                              return _vm.changeStatus(item)
                            },
                          },
                          model: {
                            value: item.Active,
                            callback: function ($$v) {
                              _vm.$set(item, "Active", $$v)
                            },
                            expression: "item.Active",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "item.editar",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "", color: "warning", title: "Editar" },
                        on: {
                          click: function ($event) {
                            return _vm.editar(item)
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v(" mdi-pencil ")])],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("download-audit-dialog", {
        attrs: { company: _vm.selectedAlianza, type: _vm.downloadType },
        on: { download: _vm.downloadAudit },
        model: {
          value: _vm.showDownloadDialog,
          callback: function ($$v) {
            _vm.showDownloadDialog = $$v
          },
          expression: "showDownloadDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }